import * as React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Header from "./Header";
import MainFeaturedPost from "./MainFeaturedPost";
import FeaturedPost from "./FeaturedPost";
import { ZhumiFooter } from "../../component/ZumiFooter";

const sections = [
  { title: "首页", url: "/" },
  { title: "控制台", url: "/console" },
];

//商业图库 https://source.unsplash.com/random
const mainFeaturedPost = {
  title: "欢迎访问竹米开放平台",
  description:
    "目前平台主要提供远程桌面访问服务，内网Web服务映射服务。借助于竹米开放平台分配的网络通道地址即可实现内网服务的外网映射。对于程序员开发联调，远程办公，个人博主特别合适。",
  image:
    "https://knowledgebase.msyidai.com/material/view/c8fc4b4b-9b2b-4f34-ba54-9ee8701cb89a",
  imageText: "竹米",
  linkText: "",
};

const featuredPosts = [
  {
    title: "如何开启Windows远程桌面",
    date: "2022-10-19 11:34",
    description:
      "这篇文章将一步步指引你如何在windows系列的电脑上开启远程桌面服务",
    image: "images/1.png",
    imageLabel: "Windows电脑如何开启远程桌面",
    url: "https://blog.joemeet.com/document/15080591368130560/view",
  },
  {
    title: "如何申请远程桌面通道",
    date: "2022-10-22 12:14",
    description: "讲解如何使用平台提供的桌面通道访问您远程的电脑",
    image: "images/2.png",
    imageLabel: "申请远程桌面通道",
    url: "https://blog.joemeet.com/document/15119666783457280/view",
  },
  {
    title: "如何创建Web网站",
    date: "2022-10-21 15:34",
    description:
      "本文将讲解如何使用竹米开发平台提供的通道来访问您部署在内网Web服务器（Jenkins，禅道，个人博客，tomcat，nginx，springboot，apache）等等。",
    image: "images/3.png",
    imageLabel: "如何映射内网Web服务",
    url: "https://blog.joemeet.com/document/15130178699137024/view",
  },
];

export default function Blog() {
  const [keyWord, setKeyWord] = React.useState("");
  console.log("keyword=", keyWord);
  return (
    <Container maxWidth="lg">
      <Header
        title="竹米开放平台"
        queryCallback={setKeyWord}
        sections={sections}
      />
      <main>
        <MainFeaturedPost post={mainFeaturedPost} />
        <Grid container spacing={4}>
          {featuredPosts.map((post) => {
            if (
              !keyWord ||
              post.title.toLowerCase().indexOf(keyWord) !== -1 ||
              post.description.toLowerCase().indexOf(keyWord) !== -1
            ) {
              return <FeaturedPost key={post.title} post={post} />;
            }
            return <></>;
          })}
        </Grid>
      </main>
      <ZhumiFooter></ZhumiFooter>
    </Container>
  );
}
